import { DataBaseModelInterface } from '@solcre-org/core';
import { PortModel } from './port.model';

export class QuoteModel implements DataBaseModelInterface {
  constructor(
    public id?: string,
    public quoteNumber?: string,
    public client?: string,
    public clientComercialName?: string,
    public status?: string,
    public amount?: number,
    public currency?: string,
    public expirationDate?: string,
    public podPort? : PortModel,
    public polPort? : PortModel,
  ) {}

  public fromJSON(json: any): QuoteModel {
    if (json) {
      this.id = json.id;
      this.quoteNumber = json.quoteNumber;
      this.client = json.client?.id;
      this.clientComercialName = json.client?.commercialName;
      this.status = json.status;
      this.amount = json.amount ?? 0;
      this.currency = json.currency;
      this.expirationDate = json.expirationDate;
      this.podPort = json.podPort;
      this.polPort = json.polPort;
    }
    return this;
  }

  public fromJSONList(json: any): QuoteModel[] {
    if (json) {
      return json.map((element: any) => new QuoteModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      quoteNumber: this.quoteNumber,
      amount: this.amount,
      currency: this.currency,
      client: this.client,
      clientComercialName: this.clientComercialName,
      status: this.status,
      expirationDate: this.expirationDate,
      pod: this.podPort,
      pol: this.polPort,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }
}
